import { gql } from '@apollo/client';
import list from './List';
import create from './Create';
import show from './Show';

export default {
  name: 'professionalTravelPositions',
  inputShow: gql`
    query professionalTravelPositions($input: ProfessionalTravelPositionQueryInput) {
      professionalTravelPositions(input: $input) {
        id
        __typename
      }
    }
  `,
  list,
  show,
  create,
  options: {
    group: 'Misc',
    label: 'Professional Travel Positions',
  },
};
